module.exports = __webpack_public_path__ + "static/media/iconList.942a93c4.svg";